// extracted by mini-css-extract-plugin
export default {"imageWithFullScreen":"LkeRHycnLEG1FIlU_DMA"};